import { indexes, pixToMm } from './constants';
import { orientation as Orientation, PageSizes } from './';
import { IPrintConfiguration } from '../../helpers/printOptions.service';
import { HeaderStyle } from '../../../models/enum';
import { convertHeaderStyle } from '../../../states/scaledPrintPreview/convertHeaderStyle';

export function rowsCount(printConfiguration: IPrintConfiguration, widgetMargin: number, rowHeight: number, adapter: number): number {
    const sizeInPx = computeSizeInPixels(widgetMargin, printConfiguration, adapter);
    const rowsCount = Math.floor(sizeInPx.height / rowHeight);
    return rowsCount;
}

export function computeSizeInPixels(widgetMargin: number, printConfiguration: IPrintConfiguration, adapter: number) {
    const { printOptions } = printConfiguration;
    const { format, orientation } = printOptions;
    const size = PageSizes[indexes[format]];
    let pageWidth;
    let pageHeight;
    if (orientation === Orientation.Portrait) {
        pageWidth = size.width;
        pageHeight = size.height;
    } else {
        pageHeight = size.width;
        pageWidth = size.height;
    }
    // magic adapter to account for margins??
    pageWidth -= adapter * pixToMm;
    pageHeight -= adapter * pixToMm;
    const widthInPx = Math.round(pageWidth * pixToMm) - 2 * widgetMargin;
    const heightInPx = Math.round(pageHeight * pixToMm) - headerHeight(printConfiguration)
        - 2 * widgetMargin;

    return {
        height: heightInPx,
        width: widthInPx
    };
}

function headerHeight(printConfig: IPrintConfiguration) {
    convertHeaderStyle(printConfig);
    return printConfig.headerStyle === HeaderStyle.None
        ? 0
        : (printConfig.headerStyle === HeaderStyle.Compact
            ? 50
            : 165);
}